const EOEEPage = () => {
  return (
    <div>
      Раздел в разработке
    </div>
  );
};

export default EOEEPage;